import React from 'react';
import { Form, Popover, Select } from 'antd';
import ColumnHeightOutlined from '@ant-design/icons/ColumnHeightOutlined';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';
import { styleFieldName } from '../../utils/styleFormFieldNames';
import { LINE_HEIGHT_OPTIONS } from './styleEditorConstants';

type Props = {
  namePrefix?: string | string[];
};

const LineHeightSelect: React.FC<{
  value?: number;
  onChange?: (value: number) => void;
}> = ({ value = 1, onChange }) => (
  <Popover
    trigger="click"
    getPopupContainer={() => document.body}
    placement="bottom"
    title="Line spacing"
    content={
      <div style={{ padding: 4 }}>
        <div style={{ fontSize: 12, marginBottom: 6 }}>Line height</div>
        <Select
          size="small"
          style={{ width: 120 }}
          value={value}
          options={LINE_HEIGHT_OPTIONS}
          onChange={onChange}
        />
      </div>
    }
  >
    <span>
      <RibbonIconButton title="Line height">
        <ColumnHeightOutlined />
      </RibbonIconButton>
    </span>
  </Popover>
);

export const LineHeightControl: React.FC<Props> = ({ namePrefix }) => (
  <Form.Item name={styleFieldName(namePrefix, 'lineHeight')} initialValue={1} noStyle>
    <LineHeightSelect />
  </Form.Item>
);
